@if (orderLines.length > 0) {
  <div class="order-products">
    @for (product of orderLines; track product) {
      <custom-input [inputType]="inputTypeEnum.Checkbox"
        [class]="product.invoiced != null ? 'disabled' : ''"
      [(value)]="product.sendInvoice"></custom-input>
      <div>{{ product.productVariant?.name }} {{ 'product-launch-ready.' + readyForLaunch(product) | translate }}</div><br/>
    }
    <submit-button
      #sendInvoiceButton
      (click)="sendInvoice()"
      [active]="canSendInvoice()"
      [ignoreValidation]="true"
    [label]="'product-launch.send-invoice' | translate"></submit-button>
  </div>
}
